export const company = ({company}) => company



// WEBPACK FOOTER //
// ./src/app/config/store/modules/company/getters.js